/** @typedef {import('./Props').default} Props */

import { translate } from '../../../Internationalization';
import images from '../../../../config/local/images';
import InlineSVG from 'react-inlinesvg';
import mapVendorCategories from './mapVendorCategories';
import React from 'react';
import SelectOptionList from '../../../../shared/Forms/Inputs/SelectOptionList';

/**
 * @param {Props} props
 * @returns {JSX.Element}
 */
function VendorsCategory(props) {
	return (
		<fieldset className="input-group max-w-xs mb-6">
			<label className="input-label" htmlFor="category">
				{translate('agent.pages.offers.view.select_category')}
			</label>

			<div className="input-stylized">
				<i className="icon input-icon icon-sm">
					<InlineSVG src={images.icons.arrow.dropdown.normal} />
				</i>

				<select
					className="input"
					disabled={props.isGettingData ?? false}
					name="category"
					onChange={(event) =>
						props.onSelectCategory(event.target.value)
					}
				>
					<SelectOptionList
						values={mapVendorCategories(props.categories)}
					/>
				</select>
			</div>
		</fieldset>
	);
}

export default React.memo(VendorsCategory);
